import { Pipe, PipeTransform } from '@angular/core';
import { Icon, IconItem } from '@sb/library/base';
import { SocialMediaLinksManager } from '../social-media-links.manager';
import { SocialMediaLinkDisplayItem, SocialMediaLinkInputItem } from '@sb/library/data-models';

@Pipe({name: 'socialMediaLinkIcon'})
export class SocialMediaLinkIconPipe implements PipeTransform {

    constructor(private _SocialMediaLinksManager: SocialMediaLinksManager) {
    }

    transform(socialMedia: SocialMediaLinkDisplayItem | SocialMediaLinkInputItem): IconItem {
        let iconName = this._SocialMediaLinksManager.GetSocialMediaIcon(socialMedia.SocialMediaType);
        if (!iconName) {
            iconName = Icon.Common.Language;
        }
        return iconName;
    }
}
